import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';
import pagesEn from './locales/pages-en.json';
import pagesEs from './locales/pages-es.json';

// Initialize i18next
void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: { ...en, ...pagesEn }
            },
            es: {
                translation: { ...es, ...pagesEs }
            },
        },
        fallbackLng: 'en',
        supportedLngs: ['en', 'es'],
        interpolation: { escapeValue: false },
        detection: {
            // Order and from where user language should be detected
            order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
            // Keys or params to lookup language from
            lookupLocalStorage: 'i18nextLng',
            // Cache user language on
            caches: ['localStorage'],
        },
    });

export default i18n;


